import React from "react";
import HeroSection from "./HeroSection";
import HowItWorks from "./HowItWorks";
import Services from "./Services";
import Support from "./Support";
import WhatWeOffer from "./WhatWeOffer";

type Props = {
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
};

const ServicesPage = ({ setIsOpen }: Props) => {
  return (
    <div className="flex flex-col overflow-hidden mx-auto max-w-screen-2xl items-center justify-center">
      <HeroSection setIsOpen={setIsOpen} />
      <Services />
      <WhatWeOffer setIsOpen={setIsOpen} />
      <HowItWorks />
      <Support />
    </div>
  );
};

export default ServicesPage;
